import chatimeImage from '../assets/icon/icon-1.png';
import sodexoImage from '../assets/icon/icon-2.png';
import vacherinImage from '../assets/icon/icon-3.png';
import boxedImage from '../assets/icon/icon-4.png';
import breazImage from '../assets/icon/icon-5.png';
import lexEatsImage from '../assets/icon/icon-6.png';
import pearPayImage from '../assets/icon/icon-7.png';
import canteenImage from '../assets/icon/icon-8.png';
import sandboxImage from '../assets/icon/icon-9.png';
import atalianImage from '../assets/icon/icon-10.png';
import lantanaImage from '../assets/icon/icon-11.png';
import amexImage from '../assets/icon/icon-12.png';
import threeImage from '../assets/icon/icon-13.png';
import sonyKitchenImage from '../assets/icon/icon-14.png';
import refuelImage from '../assets/icon/icon-15.png';
import jpmcImage from '../assets/icon/icon-16.png';
import { translate } from './translation';

export const statuses = ["PREPARING", "READY"];

const normaliseDisplayMode = (value) => {
    if (!value) {
        return 'Default';
    }

    const displayModeMap = {
        'extra small': 'Extra Small',
        'extrasmall': 'Extra Small',
        'xs': 'Extra Small',
        'small': 'Small',
        's': 'Small',
        'medium': 'Medium',
        'm': 'Medium',
        'large': 'Large',
        'l': 'Large',
        'extra large': 'Extra Large',
        'extralarge': 'Extra Large',
        'xl': 'Extra Large',
        'dynamic': 'Dynamic',
        'default': 'Default',
    };

    const normalisedValue = value.toString().trim().toLowerCase().replace(/[_\-]+/g, ' ');
    return displayModeMap[normalisedValue] || 'Default';
};

const partnersData = [
    {
        applicationId: 1,
        partnerId: 4,
        logoChoice: false,
        image: chatimeImage,
        appStore: 'https://apps.apple.com/gb/app/chatime-uk/id1225902100',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.chatime',
        website: 'https://chatime.dynamify.com',
        appName: 'Chatime UK: Pickup & Delivery'
    },
    {
        applicationId: 2,
        partnerId: 9,
        logoChoice: false,
        image: sodexoImage,
        appStore: 'https://apps.apple.com/gb/app/twelve-by-sodexo/id1338702323',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.sodexo&hl=en_GB',
        website: 'https://twelve.dynamify.com',
        appName: 'Everyday'
    },
    {
        applicationId: 3,
        partnerId: 10,
        logoChoice: false,
        image: vacherinImage,
        appStore: 'https://apps.apple.com/gb/app/vacherin-catering/id1437423714',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.vacherin',
        website: 'https://vacherin.dynamify.com',
        appName: 'Vacherin Catering'
    },
    {
        applicationId: 4,
        partnerId: 10,
        logoChoice: true,
        image: boxedImage,
        appStore: 'https://apps.apple.com/gb/app/boxed-app/id1518041487',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.chco',
        website: 'https://boxed.dynamify.com',
        appName: 'Boxed'
    },
    {
        applicationId: 5,
        partnerId: 11,
        logoChoice: false,
        image: breazImage,
        image2: lexEatsImage,
        appStore: 'https://apps.apple.com/us/app/breaz/id1486594552',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.elior',
        website: 'https://breaz.dynamify.com',
        appName: 'Breaz'
    },
    {
        applicationId: 6,
        partnerId: 11,
        logoChoice: true,
        image: lexEatsImage,
        appStore: 'https://apps.apple.com/gb/app/lexeat/id1195558110',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.lexington',
        website: 'https://lexeats.dynamify.com',
        appName: 'LexEats'
    },
    {
        applicationId: 9,
        partnerId: 12,
        logoChoice: false,
        image: sandboxImage,
        appStore: 'https://apps.apple.com/gb/app/dynamify-sandbox/id1511167977',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.sandbox',
        website: 'https://www.sandbox.dynamify.com',
        appName: ''
    },
    {
        applicationId: 7,
        partnerId: 13,
        logoChoice: false,
        image: pearPayImage,
        appStore: 'https://apps.apple.com/gb/app/pearpay/id1511733597',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.bartlettmitchell',
        website: 'https://pearpay.dynamify.com',
        appName: 'PearPay'
    },
    {
        applicationId: 8,
        partnerId: 13,
        logoChoice: true,
        image: canteenImage,
        appStore: 'https://apps.apple.com/gb/app/canteen/id1579691205',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.five',
        website: 'https://canteen.dynamify.com',
        appName: 'Canteen'
    },
    {
        applicationId: 14,
        partnerId: 13,
        logoChoice: true,
        image: sonyKitchenImage,
        appStore: 'https://apps.apple.com/gb/app/sonykitchen/id1621588998',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.sonykitch',
        website: 'https://sonykitchen.dynamify.com',
        appName: 'Sony Kitchen'
    },
    {
        applicationId: 10,
        partnerId: 14,
        logoChoice: false,
        image: atalianImage,
        appStore: 'https://apps.apple.com/gb/app/angel-hill/id1512795493',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.angelfood',
        website: 'https://atalianservest.dynamify.com',
        appName: 'Atalian Servest'
    },
    {
        applicationId: 11,
        partnerId: 15,
        logoChoice: false,
        image: lantanaImage,
        appStore: 'https://apps.apple.com/gb/app/lantana/id1572863371',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.lantana',
        website: 'https://lantana.dynamify.com',
        appName: 'Lantana Residencies'
    },
    {
        applicationId: 12,
        partnerId: 16,
        logoChoice: false,
        image: amexImage,
        appStore: 'https://apps.apple.com/gb/app/food2you-at-amex/id1572863041',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.amex',
        website: 'https://amex.dynamify.com',
        appName: 'Food2You'
    },
    {
        applicationId: 13,
        partnerId: 17,
        logoChoice: false,
        image: threeImage,
        appStore: 'https://apps.apple.com/gb/app/food-at-three/id1606911449',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.three',
        website: 'https://3.dynamify.com',
        appName: 'Food @ Three'
    },
    {
        applicationId: 15,
        partnerId: 18,
        logoChoice: false,
        image: refuelImage,
        appStore: 'https://apps.apple.com/gb/app/refuel/id6446634031',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.iss',
        website: 'https://refuel.dynamify.com',
        appName: 'Refuel: Make Life Easier'
    },
    {
        applicationId: 16,
        partnerId: 19,
        logoChoice: false,
        image: jpmcImage,
        appStore: 'https://apps.apple.com/gb/app/efeed/id6446634916',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.dynamify.jpmc',
        website: 'https://efeed.dynamify.com',
        appName: 'efeed'
    },
];


// export const parseURLBuildingId = () => {
//     const params = new URL(window.location.href).searchParams;
//     return (params.get('buildingId') || '');
// };
// export const parseURLUserId = () => {
//     const params = new URL(window.location.href).searchParams;
//     return (params.get('userId') || '');
// };
export const parseURLuid = () => {
    const params = new URL(window.location.href).searchParams;
    return (params.get('uid') || '');
};


export const getOrderStatusSettings = async (uid) => {
    return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/order-status?uid=${uid}&key=${process.env.REACT_APP_KEY}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(data => {return data.json()}).catch()
};

export const setPrimaryColour = (color) => {
    document.documentElement.style.setProperty('--primaryColour', '#' + color);
};
export const setPreparingPrimaryColour = (color) => {
    document.documentElement.style.setProperty('--preparingPrimaryColour', '#' + color);
};
export const setCompletedPrimaryColour = (color) => {
    document.documentElement.style.setProperty('--completedPrimaryColour', '#' + color);
};
export const setFontFamily = (font) => {
    document.documentElement.style.setProperty('--font-family', font);
};

export const getPartnerData = (partnerId = 12, logoChoice = false) => {
    const partner = partnersData.find(partnersData => partnersData.partnerId === partnerId && partnersData.logoChoice === logoChoice);
    if (partner) {
        const { defaultLanguage } = getLocalUserInfoLocalStorage();
        const language = defaultLanguage || 'en';
        if (partner.appName && partner.appName !== '') {
            const app = `'${partner.appName}'`;
            partner.text = translate('DOWNLOAD_APP_TEXT', language).replace('{app}', app);
        } else {
            partner.text = translate('DOWNLOAD_APP_TEXT_GENERIC', language);
        }
    }
    return partner;
};

// export const loginUsers = async (credentials) => {
//     return fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/login`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(credentials)
//     })
//         .then(data => data.json())
// };

// export const logoutUsers = async (token) => {
//     return fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/logout`, {
//         method: 'POST',
//         headers: {
//             'Content-Type': 'application/json',
//             'X-Auth-Token': token
//         }
//     })
//         .then((response) => {
//             return response;
//         })
//         .then(() => {
//             return true;
//         })
//         .catch((error) => {
//             throw new Error(error);
//         });
// };

export const customerDetails = async (tradeIdArray = [], storeIds = '') => {
    return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/trade/customerDetails?filler=true&key=${process.env.REACT_APP_KEY}` +
        (tradeIdArray.length > 0 ? `&tradeIds=${tradeIdArray.join(',')}` : ``) +
        (storeIds.length > 0 ? `&storeIds=${storeIds.join(',')}` : ``), {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(data => {return data.json()}).catch()
};
// export const listStores = async (token) => {
//     return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/stores-list`, {
//         method: 'GET',
//         headers: {
//             'Content-Type': 'application/json',
//             'X-Auth-Token': token
//         },
//     }).then((response) => response.json())
//         .then((result) => {
//             return result;
//         })
//         .catch((error) => {
//             throw new Error(error);
//         });
// };


export const setLocalOrderStatusSettings = (orderStatusSettings) => {
    localStorage.setItem("orderStatusSettings", JSON.stringify(orderStatusSettings));
};
// export const getLocalOrderStatusSettings = () => {
//     const localOrderStatusSettings = localStorage.getItem("orderStatusSettings");
//     return localOrderStatusSettings ? JSON.parse(localOrderStatusSettings) : null;
// };
export const getLocalUserInfoLocalStorage = () => {
    let buildingId, storeIds, storeNames;
    let color, primaryColour, preparingPrimaryColour, completedPrimaryColour, font;
    let showCustomerId, showCustomerFirstName, showCustomerLastName, showStoreName;
    let showWaitTime, showCollectionPoint, collectionPointName, peopleAhead, logoChoice, showLoyalty;
    let partnerId, subIds, landScape, showLogo, showDownload;
    let logoURL, optionalResources, defaultLanguage, type, displayMode;

    const orderStatusSettings = localStorage.getItem("orderStatusSettings") || '';
    if (orderStatusSettings !== '') {
        const params = JSON.parse(orderStatusSettings);
        buildingId = (params['buildingId'] || '');
        storeIds = (params['storeIds'] || '').split(',');
        storeNames = (params['storeNames'] || '').split(',');
        color = (params['color'] || '').replace("#", "") || 'ffffff';
        primaryColour = (params['primaryColour'] || '').replace("#", "") || '000506';
        preparingPrimaryColour = (params['preparingPrimaryColour'] || '').replace("#", "") || 'fcb42e';
        completedPrimaryColour = (params['completedPrimaryColour'] || '').replace("#", "") || '67ec67';
        font = params['font'] || '\'Nunito\', sans-serif';
        if (font.indexOf("TT Norms") > -1) {
            font = '\'Nunito\', sans-serif';
        }
        showCustomerId = (params['customerId'] || false).toString().toLowerCase() === 'true';
        showCustomerFirstName = (params['customerFirstName'] || false).toString().toLowerCase() === 'true';
        showCustomerLastName = (params['customerLastName'] || false).toString().toLowerCase() === 'true';
        showStoreName = (params['storeName'] || false).toString().toLowerCase() === 'true';
        showWaitTime = (params['showWaitTime'] || false).toString().toLowerCase() === 'true';
        showCollectionPoint = (params['showCollectionPoint'] || false).toString().toLowerCase() === 'true';
        collectionPointName = params['collectionPointName'] || '';
        peopleAhead = (params['peopleAhead'] || false).toString().toLowerCase() === 'true';
        logoChoice = (params['logoChoice'] || false).toString().toLowerCase() === 'true';
        showLoyalty = (params['loyalty'] || false).toString().toLowerCase() === 'true';
        partnerId = !isNaN(Number(params['partnerId'] || 12)) ? Number(params['partnerId']) : 12;
        subIds = (params['subIds'] || '') ? (params['subIds'] || '').split(',') : [];
        landScape = params['landScape'] || false;
        showLogo = params['showLogo'] || false;
        showDownload = params['showDownload'] || false;
        logoURL = params['photoFilename'] || '';
        if (logoURL) {
            logoURL = 'https://images.dynamify.com/order-status-logos/' + logoURL;
        }
        optionalResources = params['optionalResources'] || [];
        defaultLanguage = params['defaultLanguage'] || 'en';
        type = (params['type'] || 'Both');
        displayMode = normaliseDisplayMode(params['displayMode']);
        if (typeof optionalResources === 'string') {
            try {
                optionalResources = JSON.parse(optionalResources);
            } catch (e) {
                optionalResources = [];
            }
        }
    } else {
        const params = new URL(window.location.href).searchParams;
        buildingId = (params.get('buildingId') || '');
        storeIds = (params.get('storeIds') || '').split(',');
        storeNames = (params.get('storeNames') || '').split(',');
        color = (params.get('color') || '').replace("#", "") || 'ffffff';
        primaryColour = (params.get('primaryColour') || '').replace("#", "") || '000506';
        preparingPrimaryColour = (params.get('preparingPrimaryColour') || '').replace("#", "") || 'fcb42e';
        completedPrimaryColour = (params.get('completedPrimaryColour') || '').replace("#", "") || '67ec67';
        font = params.get('font') || '\'Nunito\', sans-serif';
        if (font.indexOf("TT Norms") > -1) {
            font = '\'Nunito\', sans-serif';
        }
        showCustomerId = (params.get('customerId') || false).toString().toLowerCase() === 'true';
        showCustomerFirstName = (params.get('customerFirstName') || false).toString().toLowerCase() === 'true';
        showCustomerLastName = (params.get('customerLastName') || false).toString().toLowerCase() === 'true';
        showStoreName = (params.get('storeName') || false).toString().toLowerCase() === 'true';
        showWaitTime = (params.get('showWaitTime') || false).toString().toLowerCase() === 'true';
        showCollectionPoint = (params.get('showCollectionPoint') || false).toString().toLowerCase() === 'true';
        collectionPointName = params.get('collectionPointName') || '';
        peopleAhead = (params.get('peopleAhead') || false).toString().toLowerCase() === 'true';
        logoChoice = (params.get('logoChoice') || false).toString().toLowerCase() === 'true';
        showLoyalty = (params.get('loyalty') || false).toString().toLowerCase() === 'true';
        partnerId = !isNaN(Number(params.get('partnerId') || 12)) ? Number(params.get('partnerId')) : 12;
        subIds = (params.get('subIds') || '') ? (params.get('subIds') || '').split(',') : [];
        landScape = params.get('landScape') || false;
        showLogo = params.get('showLogo') || false;
        showDownload = params.get('showDownload') != null && params.get('showDownload') === 'true';
        logoURL = params.get('photoFilename') || '';
        if (logoURL) {
            logoURL = 'https://images.dynamify.com/order-status-logos/' + logoURL;
        }
        optionalResources = params.get('optionalResources') || [];
        defaultLanguage = params.get('defaultLanguage') || 'en';
        type = (params.get('type') || 'Both');
        displayMode = normaliseDisplayMode(params.get('displayMode'));
        if (typeof optionalResources === 'string') {
            try {
                optionalResources = JSON.parse(optionalResources);
            } catch (e) {
                optionalResources = [];
            }
        }
    }
    return {
        buildingId, storeIds, storeNames,
        color, primaryColour, preparingPrimaryColour, completedPrimaryColour, font,
        showCustomerId, showCustomerFirstName, showCustomerLastName, showStoreName,
        showWaitTime, showCollectionPoint, collectionPointName, peopleAhead, logoChoice, showLoyalty,
        partnerId, subIds, landScape, showLogo, showDownload,
        logoURL, optionalResources, defaultLanguage, type, displayMode
    };

};

export const getFireBaseConfigs = async (uid) => {
    return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/firebase-config?&uid=${uid}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then(data => {return data.json()}).catch()
};

export const listTrades = async (storeId) => {
    return fetch(`${process.env.REACT_APP_AWS_ENDPOINT}/trades/order-status?storeId=` + storeId + `&key=${process.env.REACT_APP_KEY}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((response) => response.json())
        .then((result) => {
            return result;
        })
        .catch((error) => {
            throw new Error(error);
        });
};

